import React from 'react';
import SideNav from './SideNav';
import './ContactUs.css'; // optional custom styling for fine-tuning

const ContactUs = () => {
  return (
    <div className="contact-page">
      <>
        {/* Page Header */}
        <div className="page-header-contactus parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Contact Us
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="services" className="btn-default btn-highlighted">Our Services</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="page-service-single">
          <div className="container">
            <div className="row">
              
              {/* Left Section – Contact Form */}
              <div className="col-lg-8">
                <div className="service-single-content">
                  {/* Contact Form */}
                  <div className="section-title mb-4">
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Get In <span>Touch</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Have a question or a project in mind? We’d love to hear from you!  
                      Reach out to our design and construction experts, and we’ll help turn your vision into reality.
                    </p>
                  </div>

                  <form className="contact-form wow fadeInUp" data-wow-delay="0.4s">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <input type="text" name="name" className="form-control" placeholder="Your Name" required />
                      </div>
                      <div className="col-md-6">
                        <input type="email" name="email" className="form-control" placeholder="Your Email" required />
                      </div>
                      <div className="col-md-6">
                        <input type="text" name="phone" className="form-control" placeholder="Your Phone" />
                      </div>
                      <div className="col-md-6">
                        <input type="text" name="subject" className="form-control" placeholder="Subject" />
                      </div>
                      <div className="col-12">
                        <textarea name="message" rows="5" className="form-control" placeholder="Your Message" required></textarea>
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn-default btn-highlighted w-100">Send Message</button>
                      </div>
                    </div>
                  </form>

                  {/* Office Info */}
                  <div className="contact-info mt-5 wow fadeInUp" data-wow-delay="0.3s">
  <h2 className="text-anime-style-2 mb-3" data-cursor="-opaque">
    Our <span>Office</span>
  </h2>
  <p>
    Visit our design studio or reach out through the following channels.  
    We’re always here to assist you with your interior and construction needs.
  </p>

  <div className="office-details">
    <div className="office-item">
      <i className="fa-solid fa-location-dot"></i>
      <div>
        <strong>MeHome Interiors & Construction</strong><br />
        Kukatpally, Hyderabad, India
      </div>
    </div>

    <div className="office-item">
      <i className="fa-solid fa-phone"></i>
      <div>
         
        <a href="tel:+916300099622">+91 9550 278 055</a>
      </div>
    </div>

    <div className="office-item">
      <i className="fa-solid fa-envelope"></i>
      <a href="mailto:contact@mehome.co.in">contact@mehome.co.in</a>
    </div>

    <div className="office-item">
      <i className="fa-solid fa-globe"></i>
      <a href="https://www.mehome.co.in" target="_blank" rel="noopener noreferrer">
        www.mehome.co.in
      </a>
    </div>
  </div>

  <div className="social-icons mt-4">
    <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
    <a href="#"><i className="fa-brands fa-instagram"></i></a>
    <a href="#"><i className="fa-brands fa-pinterest"></i></a>
    <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
  </div>
</div>


                  {/* Google Map */}
                  <div className="map-section mt-5 wow fadeInUp" data-wow-delay="0.5s">
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Find <span>Us</span>
                    </h2>
                    <div className="mapouter">
                      <div className="gmap_canvas">
                        <iframe
                          title="MeHome Location"
                          width="100%"
                          height="400"
                          id="gmap_canvas"
                          src="https://maps.google.com/maps?q=Kukatpally%20Hyderabad&t=&z=13&ie=UTF8&iwloc=&output=embed"
                          frameBorder="0"
                          scrolling="no"
                          marginHeight="0"
                          marginWidth="0"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Section – Sidebar */}
              <div className="col-lg-4">
                <SideNav />
              </div>

            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default ContactUs;
